import React from "react";
import Assessment from "./components/Assessment";
import "./App.css";

function App() {
  // Show assessment directly - routing not working on static hosting
  return (
    <div className="App">
      <Assessment />
    </div>
  );
}

export default App;
